import { useEffect, useState } from 'react'

/* Een kleine router: het pad is de staat. */

const luisteraars = new Set<() => void>()

export function ga(pad: string, vervang = false) {
  if (pad === location.pathname + location.search) return
  if (vervang) history.replaceState(null, '', pad)
  else history.pushState(null, '', pad)
  luisteraars.forEach((f) => f())
  window.scrollTo(0, 0)
}

export function usePad(): string {
  const [pad, zet] = useState(location.pathname)
  useEffect(() => {
    const f = () => zet(location.pathname)
    luisteraars.add(f)
    window.addEventListener('popstate', f)
    return () => { luisteraars.delete(f); window.removeEventListener('popstate', f) }
  }, [])
  return pad
}

/** Een link die binnen de app blijft. */
export function klikNaar(pad: string) {
  return (e: { preventDefault(): void; metaKey?: boolean; ctrlKey?: boolean }) => {
    if (e.metaKey || e.ctrlKey) return
    e.preventDefault()
    ga(pad)
  }
}
